import React, { useState, useEffect } from 'react';
import { MdLocationOn, MdEdit, MdPeople, MdCategory, MdDescription, MdEnergySavingsLeaf, MdLandscape, MdWaterDrop, MdQrCode2, MdAttachMoney } from 'react-icons/md';
import { FaBuilding, FaCheck, FaTimes } from 'react-icons/fa';
import { getUser } from '../utils';
import CustomMap from '../components/CustomMap';
import { farmerResponses, updateFarmerProfile, uploadFarmerImage } from '../api';
import { toast } from 'react-toastify';
import ImageCropModal from '../components/modal/ImageCropModal';
import { useNavigate, useParams } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import { useApp } from '../context/AppContext';
import InfoCard from '../components/InfoCard';
import SpendDistribution from '../components/SpendDistribution';
import InnerLoader from '../components/microComponents/InnerLoader';
import QRCode from 'qrcode';
import { PiCertificateFill } from "react-icons/pi";
import { PiPlantFill } from "react-icons/pi";

const AboutFarmer = () => {

    const navigate = useNavigate();

    const user = getUser();

    const [farmerDetails, setFarmerDetails] = useState(null);

    const [profileImage, setProfileImage] = useState(user?.profile_pic || user?.farmer?.profile_pic || null);

    const [isUploading, setIsUploading] = useState(false);
    const [cropModalOpen, setCropModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const [isEditingDescription, setIsEditingDescription] = useState(false);
    const [description, setDescription] = useState(farmerDetails?.farmer?.description || '');
    const [tempDescription, setTempDescription] = useState('');

    const { updateUser } = useApp();
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [isUpdatingDescription, setIsUpdatingDescription] = useState(false);

    useEffect(() => {
        setLoading(true);
        if (!farmerDetails?.answers) {
            farmerResponses(id ?? user?._id).then((res) => {
                if (user?.farmer && !user?.about_me) {
                    updateUser({ ...user, about_me: res?.farmer?.about_me })
                }
                if (!profileImage) {
                    setProfileImage(res?.farmer?.profile_pic || res?.farmer?.farmer?.profile_pic);
                }
                setDescription(res?.farmer?.about_me)
                const farmer = res?.farmer;
                const answers = res?.answers;
                // Ethnicity is a single value
                const ethnicity = answers?.find(a => a?.question?.order === 1)?.text;
                // Category is an array of objects
                const category = answers?.find(a => a?.question?.order === 2)?.text;
                const answerOrder20 = answers?.find(a => a?.question?.order === 20)?.text;

                setFarmerDetails({
                    farmer: farmer ?? null,
                    answers: answers ?? null,
                    farm: farmer?.farmer?.farm ?? null,
                    first_name: farmer?.farmer?.first_name ?? null,
                    last_name: farmer?.farmer?.last_name ?? null,
                    ethnicity: ethnicity ?? null,
                    category: category ?? null,
                    certification: answers?.find(a => a?.question?.order === 18)?.text[0]?.value ?? null ?? null,
                    state: farmer?.farmer?.farm?.state ?? null,
                    renewableEnergyPercentage: answers?.find(a => a?.question?.order === 5)?.number ?? null,
                    // procurementDiversityPercentage: answers?.find(a => a?.question?.order === 7)?.number ?? null,
                    totalAcreage: answers?.find(a => a?.question?.order === 10)?.number ?? null,
                    // organicSoilPracticesPercentage: answers?.find(a => a?.question?.order === 11)?.number ?? null,
                    organicSoilPracticesPercentage: answerOrder20 ?? null,
                    waterConservation: answers?.find(a => a?.question?.order === 4)?.number ?? null,
                    // totalProductVolume: answers?.find(a => a?.question?.order === 15)?.number ?? null,
                    spendDistribution: answers?.find(a => a?.question?.order === 16)?.text ?? null,
                    businessValueIncrease: answers?.find(a => a?.question?.order === 19)?.number ?? null,

                })
            }).catch(err => {
                console.error("🚀 ~ useEffect ~ err:", err)
                toast.error("Failed to fetch farmer answers")
            }).finally(() => {
                setLoading(false);
            })
        } else {
            const answers = user?.answers;
            const answerOrder5 = answers?.find(a => a?.question?.order === 5);
            // const answerOrder7 = answers?.find(a => a?.question[0]?.order === 7);
            const answerOrder10 = answers?.find(a => a?.question?.order === 10);
            const answerOrder12 = answers?.find(a => a?.question?.order === 4);
            // const answerOrder15 = answers?.find(a => a?.question[0]?.order === 15);
            const answerOrder16 = answers?.find(a => a?.question?.order === 16);
            const answerOrder18 = answers?.find(a => a?.question?.order === 18);
            const answerOrder19 = answers?.find(a => a?.question?.order === 19);
            const answerOrder20 = answers?.find(a => a?.question?.order === 20);

            setFarmerDetails({
                farmer: user?.farmer ?? null,
                answers: answers ?? null,
                farm: user?.farmer?.farm ?? null,
                first_name: user?.farmer?.first_name ?? null,
                last_name: user?.farmer?.last_name ?? null,
                ethnicity: user?.ethnicity ?? null,
                category: user?.category ?? null,
                state: user?.farmer?.farm?.state ?? null,
                renewableEnergyPercentage: answerOrder5?.number ?? null,
                // procurementDiversityPercentage: answerOrder7?.number ?? null,
                totalAcreage: answerOrder10?.number ?? null,
                // organicSoilPracticesPercentage: answerOrder11?.number ?? null,
                organicSoilPracticesPercentage: answerOrder20?.number ?? null,
                waterConservation: answerOrder12?.number ?? null,
                // totalProductVolume: answerOrder15?.number ?? null,
                spendDistribution: answerOrder16?.distribution ?? null,
                certification: answerOrder18?.text[0]?.value ?? null,
                businessValueIncrease: answerOrder19?.number ?? null,
            })
            setProfileImage(user?.profile_pic || user?.farmer?.profile_pic || null);
            setLoading(false);
        }
    }, [id])

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Validate file type
        if (!file.type.startsWith('image/')) {
            toast.error('Please upload an image file');
            return;
        }

        // Validate file size (max 5MB)
        if (file.size > 5 * 1024 * 1024) {
            toast.error('Image size should be less than 5MB');
            return;
        }

        // Create URL for the image and open crop modal
        const imageUrl = URL.createObjectURL(file);
        setSelectedImage(imageUrl);
        setCropModalOpen(true);
    };

    const handleCroppedImage = async (blob) => {
        setIsUploading(true);
        try {
            const formData = new FormData();
            formData.append('file', blob, 'file.jpg');
            formData.append('email', user?.email);

            const response = await uploadFarmerImage(formData);
            if (response?.status === 200) {
                setProfileImage(response.message);
                toast.success('Profile image updated successfully');
            } else {
                throw new Error('Invalid response format');
            }
        } catch (error) {
            console.error('Error uploading image:', error);
            toast.error('Failed to upload image');
        } finally {
            setIsUploading(false);
            setSelectedImage(null);
        }
    };

    const handleDescriptionUpdate = async () => {
        setIsUpdatingDescription(true);
        try {
            const response = await updateFarmerProfile(tempDescription);
            if (response.status === 200) {
                setDescription(tempDescription);
                setIsEditingDescription(false);
                updateUser({ ...user, about_me: tempDescription });
                toast.success('Description updated successfully');
            } else {
                toast.error('Failed to update description');
            }
        } catch (error) {
            console.error('Error updating description:', error);
            toast.error('Failed to update description');
        } finally {
            setIsUpdatingDescription(false);
        }
    };

    const handleQRDownload = async () => {
        try {
            // Get base URL
            const baseUrl = window.location.origin + '/about-farmer';

            // Determine the complete URL
            let completeURL;
            if (id) {
                // If id is in params, use the current URL
                completeURL = window.location.href;
            } else {
                // If no id in params, append current user's id
                completeURL = `${baseUrl}/${user?._id}`;
            }

            // Generate QR code as data URL
            const qrDataURL = await QRCode.toDataURL(completeURL, {
                width: 512,
                margin: 2,
                color: {
                    dark: '#006A2D',  // Dark green color for QR code
                    light: '#FFFFFF'   // White background
                }
            });

            // Create temporary link element
            const link = document.createElement('a');
            link.href = qrDataURL;
            link.download = `${farmerDetails?.first_name}-${farmerDetails?.last_name}-profile-qr.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (err) {
            console.error('Error generating QR code:', err);
            toast.error('Failed to generate QR code');
        }
    };

    return (
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-6">
            {/* Back Button */}
            {user && id && (
                <button
                    onClick={() => navigate(-1)}
                    className="mb-6 flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
                >
                    <IoArrowBack size={20} />
                    <span>Back to Farmers</span>
                </button>
            )}

            {loading ? (
                <div className="flex justify-center items-center min-h-[400px]">
                    <InnerLoader
                        divSize={{ width: "48px", height: "48px" }}
                        loaderSize={{ width: "48px", height: "48px" }}
                    />
                </div>
            ) : (
                <div className="space-y-6">
                    <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-6 space-y-6">
                        {/* Header Section - Make it stack on mobile */}
                        <div className="flex flex-col sm:flex-row sm:items-center justify-between border-b border-gray-100 pb-4 gap-4">
                            <div className="flex flex-col sm:flex-row items-center gap-4">
                                <div className="relative group w-24 sm:w-32">
                                    {profileImage ? (
                                        <img
                                            src={profileImage}
                                            alt={`${farmerDetails?.first_name} ${farmerDetails?.last_name}`}
                                            className="w-24 h-24 sm:w-32 sm:h-32 rounded-full object-cover shadow-lg"
                                        />
                                    ) : (
                                        <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full bg-gradient-to-br from-darkGreen to-green-500 text-white flex items-center justify-center text-2xl uppercase shadow-lg">
                                            {user?._id ? `${farmerDetails?.first_name?.toUpperCase()[0]} ${farmerDetails?.last_name?.toUpperCase()[0]}` : `${farmerDetails?.farm?.farm_name?.toUpperCase()[0]}`}
                                        </div>
                                    )}

                                    {/* Image Upload Button */}
                                    {user?.role === 'farmer' && <label className="absolute top-0 right-0 bg-secondaryGreen rounded-full p-1 shadow-md cursor-pointer hover:bg-primary-green transition-colors group-hover:block hidden">
                                        <input
                                            type="file"
                                            className="hidden"
                                            accept="image/*"
                                            onChange={handleImageUpload}
                                            disabled={isUploading}
                                        />
                                        <MdEdit color='white' />
                                    </label>}
                                </div>

                                <div className="text-center sm:text-left">
                                    <h2 className="px-2 text-xl sm:text-2xl font-bold text-gray-900">
                                        {user?._id ? `${farmerDetails?.first_name} ${farmerDetails?.last_name}` : `${farmerDetails?.farm?.farm_name}`}
                                    </h2>
                                    {user?._id && user?.role !== 'farmer' && <p className="px-2 mb-1 text-xs text-gray-500">
                                        {farmerDetails?.farmer?.email || user?.email}
                                    </p>}
                                    {user?._id && user?.role !== 'admin' && <p className="px-2 mb-1 text-xs text-gray-500">
                                        {farmerDetails?.farmer?.phone}
                                    </p>}
                                    <span className="px-3 py-1 bg-green-50 text-darkGreen rounded-full text-sm font-medium">
                                        {user?._id ? 'Farmer' : 'Farm'}
                                    </span>
                                </div>
                            </div>

                            {/* QR Code button */}
                            {user && <button
                                onClick={handleQRDownload}
                                className="flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-green-50 text-darkGreen hover:bg-green-100 transition-colors w-full sm:w-auto"
                                title="Download QR Code for this profile"
                            >
                                <MdQrCode2 size={20} />
                                <span>QR Code</span>
                            </button>}
                        </div>

                        {/* Details Section - Make it stack on mobile */}
                        <div className="flex flex-col lg:flex-row justify-between gap-6">
                            {/* Left Side */}
                            <div className="space-y-4 w-full lg:w-1/2">

                                {/* About Us Description */}
                                <div className="flex flex-col sm:flex-row items-start gap-4 hover:bg-gray-50 p-3 rounded-xl transition-colors">
                                    <div className="w-12 h-12 rounded-xl bg-green-50 flex items-center justify-center shadow-sm">
                                        <MdDescription className="text-2xl text-darkGreen" />
                                    </div>
                                    <div className="flex-1 w-full">
                                        <div className="flex items-center justify-between">
                                            <p className="text-sm text-gray-500">About Us</p>
                                            {user?.role === 'farmer' && (!isEditingDescription ? (
                                                <button
                                                    onClick={() => {
                                                        setTempDescription(description);
                                                        setIsEditingDescription(true);
                                                    }}
                                                    className="text-darkGreen hover:text-green-700 transition-colors"
                                                >
                                                    <MdEdit size={18} />
                                                </button>
                                            ) : (
                                                <div className="flex gap-2">
                                                    <button
                                                        onClick={handleDescriptionUpdate}
                                                        disabled={isUpdatingDescription}
                                                        className="text-green-600 hover:text-green-700 transition-colors disabled:opacity-50"
                                                    >
                                                        {isUpdatingDescription ? (
                                                            <InnerLoader
                                                                divSize={{ width: "18px", height: "18px" }}
                                                                loaderSize={{ width: "18px", height: "18px" }}
                                                            />
                                                        ) : (
                                                            <FaCheck size={18} />
                                                        )}
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            setIsEditingDescription(false);
                                                            setTempDescription('');
                                                        }}
                                                        disabled={isUpdatingDescription}
                                                        className="text-red-600 hover:text-rose-700 transition-colors disabled:opacity-50"
                                                    >
                                                        <FaTimes size={18} />
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                        {isEditingDescription ? (
                                            <textarea
                                                value={tempDescription}
                                                onChange={(e) => setTempDescription(e.target.value)}
                                                className="w-full mt-2 p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent min-h-[100px]"
                                                rows={4}
                                                placeholder="Write something about yourself..."
                                            />
                                        ) : (
                                            <p className="font-semibold text-gray-900 mt-1">
                                                {description || 'No description available'}
                                            </p>
                                        )}
                                    </div>
                                </div>

                                {/* Farm Name */}
                                {user?._id && <InfoCard
                                    icon={FaBuilding}
                                    label="Farm Name"
                                    value={farmerDetails?.farm?.farm_name}
                                />}

                                {/* Map for mobile view */}
                                <div className="lg:hidden bg-white rounded-2xl shadow-lg p-3 flex-1 hover:bg-gray-50">
                                    <div className="w-full">
                                        <CustomMap
                                            selectedRegion={farmerDetails?.state}
                                            setSelectedRegion={() => { }}
                                            geoUrl="https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json"
                                            mapData={
                                                [farmerDetails?.state]
                                            }
                                            hidePercentageBar={true}
                                            disableSelection={true}
                                            singleToneColor={true}
                                        />
                                    </div>
                                </div>

                                {/* Farm Address */}
                                <InfoCard
                                    icon={MdLocationOn}
                                    label="Farm Address"
                                    value={`${farmerDetails?.farm?.state ? `${farmerDetails?.farm?.state}, USA` : 'USA'}`}
                                />

                                {/* Ethnicity */}
                                <InfoCard
                                    icon={MdPeople}
                                    label="Ethnicity"
                                    value={farmerDetails?.ethnicity && farmerDetails?.ethnicity?.length > 0 ? farmerDetails?.ethnicity[0]?.value : null}
                                />

                                {/* Category */}
                                <InfoCard
                                    icon={MdCategory}
                                    label="Category"
                                    value={farmerDetails?.category ?? ''}
                                />
                                {/* Certification */}
                                {farmerDetails?.certification && <InfoCard
                                    icon={PiCertificateFill}
                                    label="Certifications"
                                    value={farmerDetails?.certification}
                                />}
                                {/* Renewable Energy Percentage */}
                                <InfoCard
                                    icon={MdEnergySavingsLeaf}
                                    label="Renewable Energy Usage"
                                    value={`${farmerDetails?.renewableEnergyPercentage ? farmerDetails?.renewableEnergyPercentage + '% of energy from renewable sources' : ''}`}
                                />

                                {/* Procurement Diversity */}
                                {/* <InfoCard
                                    icon={MdDiversity3}
                                    label="Procurement Diversity"
                                    value={`${farmerDetails?.procurementDiversityPercentage || 0}% from diverse suppliers`}
                                /> */}

                                {/* Sustainable Growing Practices */}
                                <InfoCard
                                    icon={PiPlantFill}
                                    label="Sustainable Growing Practices"
                                    value={farmerDetails?.organicSoilPracticesPercentage || ''}
                                />

                                {/* Total Product Volume */}
                                {/* <InfoCard
                                    icon={MdInventory}
                                    label="Annual Sourced Product Volume"
                                    value={`${farmerDetails?.totalProductVolume?.toLocaleString() || 0} lbs`}
                                /> */}

                                {/* Water Conservation */}
                                {!user?.farmer && id && <InfoCard
                                    icon={MdWaterDrop}
                                    label="Water Conservation"
                                    value={`${farmerDetails?.waterConservation?.toLocaleString() || 0} gallons preserved`}
                                />}

                                {/* Business Value Increase */}
                                <InfoCard
                                    icon={MdAttachMoney}
                                    label="Business Value Increase"
                                    value={farmerDetails?.businessValueIncrease ? `$${farmerDetails?.businessValueIncrease?.toLocaleString()}` : ''}
                                />
                            </div>

                            {/* Right Side */}
                            <div className="space-y-4 w-full lg:w-1/2">
                                {/* Map for desktop view */}
                                <div className="hidden lg:block bg-white rounded-2xl shadow-lg p-3 flex-1 hover:bg-gray-50">
                                    <div className="w-full">
                                        <CustomMap
                                            selectedRegion={farmerDetails?.state}
                                            setSelectedRegion={() => { }}
                                            geoUrl="https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json"
                                            mapData={
                                                [farmerDetails?.state]
                                            }
                                            hidePercentageBar={true}
                                            disableSelection={true}
                                            singleToneColor={true}
                                        />
                                    </div>
                                </div>

                                {/* Crop Type Delivered */}
                                <SpendDistribution distribution={farmerDetails?.spendDistribution} />

                                {/* Total Acreage */}
                                <InfoCard
                                    icon={MdLandscape}
                                    label="Total Farm Acreage"
                                    value={`${farmerDetails?.totalAcreage ? farmerDetails?.totalAcreage + ' acres' : ''}`}
                                />

                                {/* Water Conservation */}
                                {user?.farmer && <InfoCard
                                    icon={MdWaterDrop}
                                    label="Water Conservation"
                                    value={`${farmerDetails?.waterConservation ? farmerDetails?.waterConservation?.toLocaleString() + ' gallons preserved' : ''}`}
                                />}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <ImageCropModal
                isOpen={cropModalOpen}
                onClose={() => {
                    setCropModalOpen(false);
                    setSelectedImage(null);
                }}
                image={selectedImage}
                onCropComplete={handleCroppedImage}
            />
        </div>
    );
};

export default AboutFarmer; 